import { apiProvider } from "./utilities/provider";

export type AdminReferralRow = {
  ReferrerUserID: number;
  ReferrerEmail: string;

  Code: string;
  CreatedAt: string;

  TotalEarnedCents: number;
  TotalPaidCents: number;
  TotalOwedCents: number;

  ConversionsCount: number;
};

export type AdminReferralsGetResponse = {
  Rows: AdminReferralRow[];
};

export const adminReferralsApi = {
  async get(): Promise<AdminReferralsGetResponse> {
    const res: any = await apiProvider.getAll("admin/referrals");

    if (res?.data?.data) {
      return res.data.data;
    }

    if (res?.data) {
      return res.data;
    }

    return res;
  },
};
